import { Component, OnDestroy, OnInit } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DesignService, MaterialWhereUsedService } from 'src/app/state';

@Component({
  selector: 'em-material-where-used-table',
  templateUrl: './material-where-used-table.component.html',
  standalone: false,
})
export class MaterialWhereUsedTableComponent implements OnInit, OnDestroy {
  public readonly trackByRef = trackByRef;
  public readonly materialWhereUsed$ = this.materialWhereUsedService.materialWhereUsed$;
  public readonly whereUsedLoading$ = this.materialWhereUsedService.loading$;
  public readonly error$ = this.materialWhereUsedService.error$;
  public readonly designLoading$ = this.designService.loading$;

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly designService: DesignService,
    private readonly materialWhereUsedService: MaterialWhereUsedService
  ) {}

  public ngOnInit() {
    this.subscriptions.add(
      this.designService.designId$
        .pipe(switchMap((designId) => this.materialWhereUsedService.loadByDesignId(designId)))
        .subscribe()
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
